import { VerifyLinkDto } from "@api/client";
import { createReducer } from "@reduxjs/toolkit";
import AuthService from "core/auth/auth.service";
import {
	invitationGetInvitation,
	invitationReset,
	invitationSetActiveAccordion,
	invitationSetShowHeader,
} from "./actions";

export type InvitationReducerType = {
	showHeader: boolean | undefined;
	activeAccordion: number;
	invitation: VerifyLinkDto | undefined;
	province: any;
	comuni: any;
};

const initialState: InvitationReducerType = {
	showHeader: undefined,
	activeAccordion: 1,
	invitation: undefined,
	province: undefined,
	comuni: undefined,
};

export const invitationReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(invitationReset, () => {
			return initialState;
		})
		.addCase(invitationSetShowHeader, (state, action) => {
			state.showHeader = action.payload;
		})
		.addCase(invitationSetActiveAccordion, (state, action) => {
			state.activeAccordion = action.payload;
		})
		.addCase(invitationGetInvitation.fulfilled, (state, action) => {
			state.invitation = action.payload;

			AuthService.setAuthentication(action.payload?.idToken);
		});
});
